export default {
  "Data Record": "தரவு பதிவு",
  "My Storage": "எனது சேமிப்பிடம்",
  "Upgrade": "மேம்படுத்தவும்",
  "Data Size": "தரவு அளவு",
  "Folders": "கோப்புறைகள்",
  "Your file is getting upload": "கோப்பு பதிவேற்றப்படுகிறது",
  "Folder Name": "கோப்புறை பெயர்",
  "Files": "கோப்புகள்",
  "Rename Folder": "கோப்புறையை மறுபெயரிடவும்",
  "Move Folder": "கோப்புறையை நகர்த்தவும்",
  "Delete Folder": "கோப்புறையை நீக்கவும்",
  "Upload": "பதிவேற்றவும்",
  "Create Folder": "கோப்புறையை உருவாக்கவும்",
  "Uploading": "பதிவேற்றப்படுகிறது",
  "Cancel Uploading": "பதிவேற்றத்தை ரத்துசெய்யவும்",
  "Are you sure want to cancel ?": "நீங்கள் நிச்சயமாக ரத்து செய்ய விரும்புகிறீர்களா?",
  "Yes": "ஆம்",
  "No": "இல்லை",
  "Are you sure want to delete ?": "நீங்கள் நிச்சயமாக நீக்க விரும்புகிறீர்களா?",
  "Cancel": "ரத்துசெய்யவும்",
  "Delete": "நீக்கவும்",
  "Rename Folder/File": "கோப்புறை / கோப்பை மறுபெயரிடவும்",
  "Folder  Name / File Name": "கோப்புறை பெயர் / கோப்பு பெயர்",
  "Save": "சேமிக்கவும்",
  "Move File": "கோப்பை நகர்த்தவும்",
  "Move": "நகர்த்தவும்",
  "Share": "பகிரவும்",
  "Rename": "மறுபெயரிடவும்",
  "Delete": "நீக்கவும்",
  "Download": "பதிவிறக்கவும்",
  "No Data Found": "தரவு இல்லை",
  "Search": "தேடவும்...",
  "uploaded successfully": "வெற்றிகரமாக பதிவேற்றப்பட்டது",
  "You can share one file at a time": "தயவுசெய்து நேரத்தில் ஒரு கோப்பைப் பகிரவும்",
  "Choose your folder and click on move here": "ஒரு கோப்புறையைத் தேர்ந்தெடுக்கவும் மற்றும் கோப்பை அழுத்தி நகர்த்தவும்",
  "You can download one file at time": "நீங்கள் நேரத்தில் ஒரு கோப்பை பதிவிறக்கம் செய்யலாம்",
  "you can rename one file at a time": "நீங்கள் நேரத்தில் ஒரு கோப்பை மறுபெயரிடலாம்",
  "Rename successfull": "கோப்பு மறுபெயரிடப்பட்டது",
  "file Deleted Successfully": "கோப்பு நீக்கப்பட்டது",
  "Load More": "மேலும் ஏற்றவும்",
  "No more Data": "அதிக தரவு இல்லை",
  "Insufficient Memory": "आपके पास पर्याप्त जगह नहीं है"

}